// extracted by mini-css-extract-plugin
export default {"pageWrap":"Wd-z","fullWidth":"Xd-z","heading":"Yd-z","fullBleed":"Zd-z","hidden":"_d-z"};